
<div class="flex-row" *ngIf="!isLoading()">
  <div class="flex-column margin-1rem">
    <h4>{{getPackDetails('name')}}</h4>
    <span>({{getPackDetails('package_id')}})</span>
    <span>{{getPackDetails('description')}}</span>
  </div>
  <div>
    <h4>{{getPackDetails('price')}} {{getPackDetails('currency')}} </h4>
  </div>
</div>
<mat-spinner *ngIf="isLoading()"></mat-spinner>
<mat-accordion  *ngIf="!isLoading()">
    <mat-expansion-panel hideToggle *ngFor="let row of getCurrentList()">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{row.product}}
        </mat-panel-title>
        <mat-panel-description>
          <!-- This is a summary of the content -->
        </mat-panel-description>
      </mat-expansion-panel-header>
      <p>ID:{{row.id}}</p>
      <p>Description: {{row.description}}</p>
      <p>Category: {{row.category}}</p>
    </mat-expansion-panel>
</mat-accordion>